import store from '../store';

export default [
  {
    path: '/',
    name: 'TopOffer',
    component: () => import(/* webpackChunkName: "top-offer" */ '../components/templates/top-offer/TopOffer.vue'),
  },
  {
    path: '/offer/:dateFrom/:dateTo/:id/:timeSpan?',
    name: 'Offer',
    component: () => import(/* webpackChunkName: "offer" */ '../components/templates/offer/Offer.vue'),
  },
  {
    path: '/outrights/:sportId?',
    name: 'Outrights',
    component: () => import(/* webpackChunkName: "outrights" */ '../components/templates/outrights/Outrights.vue'),
  },
  {
    path: '/outrights/:sportId/:tournamentId',
    name: 'OutrightsTournament',
    component: () => import(/* webpackChunkName: "outrights-tournament" */ '../components/templates/outrights/OutrightsTournament.vue'),
  },
  {
    path: '/eventview/:id/:topOffer?',
    name: 'EventView',
    component: () => import(/* webpackChunkName: "event-view" */ '../components/templates/eventview/EventView.vue'),
  },
  {
    path: '/tickets',
    name: 'Tickets',
    component: () => import(/* webpackChunkName: "ticketHistory" */ '../components/templates/tickets/Tickets.vue'),
    beforeEnter(to, from, next) {
      import(/* webpackChunkName: "ticketsModule" */'@/store/modules/ticketHistory')
        .then((importedModule) => {
          if (!store.state.ticketHistory) store.registerModule('ticketHistory', importedModule.default);
          next();
        });
    },
  },
  {
    path: '/ticket-check',
    name: 'TicketCheck',
    component: () => import(/* webpackChunkName: "ticket-check" */ '../components/templates/ticket-check/TicketCheck.vue'),
  },
];
